import controller from './cookiesModal.controller';

let cookiesModalComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  controllerAs: 'vm'
};

export default cookiesModalComponent;



// WEBPACK FOOTER //
// ./client/app/common/cookiesModal/cookiesModal.component.js